import { BaseQueryFn, FetchArgs, fetchBaseQuery, FetchBaseQueryError } from '@reduxjs/toolkit/query/react';
import Cookies from 'js-cookie';
import { createApi } from '@reduxjs/toolkit/query/react';
import { clearPwaToken, getPwaToken } from '../../utilities/authCookie';

let isRedirectingForUnauthorized = false;

const clearSession = () => {
	clearPwaToken();
	Cookies.remove('token');
	Cookies.remove('refreshToken');
};

const rawBaseQuery = fetchBaseQuery({
	baseUrl: process.env.REACT_APP_CHAT_API_BASE_URL || '',
	prepareHeaders: (headers) => {
		const token = getPwaToken();
		if (token) {
			headers.set('Authorization', `Bearer ${token}`);
		}
		return headers;
	},
});

const baseQueryWithUnauthorizedHandling: BaseQueryFn<string | FetchArgs, unknown, FetchBaseQueryError> = async (
	args,
	api,
	extraOptions
) => {
	const result = await rawBaseQuery(args, api, extraOptions);

	if (result.error?.status === 401 && !isRedirectingForUnauthorized && window.location.pathname !== '/login') {
		isRedirectingForUnauthorized = true;
		clearSession();
		localStorage.setItem('redirectTo', window.location.pathname);
		window.location.assign('/login');
	}

	return result;
};

export const baseApi = createApi({
	reducerPath: 'api',
	baseQuery: baseQueryWithUnauthorizedHandling,
	tagTypes: ['User', 'Users', 'Program', 'Chat', 'ChatRoom', 'ChatMessage', 'PinnedMessage', 'Session', 'Feedback'],
	endpoints: () => ({}),
});
